import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as speaker from "./style.module.scss";
export const Speaker = () => {
  return (
    <section className={speaker.speaker}>
      <div className="container">
        <h2 className={`${main.blockTitle} ${main.blockTitleMdM} ${speaker.speakerTitle}`}>
          Спикер курса
        </h2>
        <div className={speaker.speaker_inner}>
          <div className="row">
            
            <div className={`col col-5 ${speaker.speaker_innerCol}`}>
              <img className={speaker.speaker_innerCol_photo} src="https://fs.advance.ru/landing-pages/online/smart/zgoda.png" alt="Александр Згода"/>
            </div>

            <div className={`col col-7 ${speaker.speaker_innerCol}`}>
              <h3 className={speaker.speaker_innerCol_title}>Александр Згода</h3>
              <ul className={speaker.speaker_innerCol_list}>
                <li className={speaker.speaker_innerCol_listStr}>
                  Эксперт в&nbsp;области мотивации, личной эффективности и&nbsp;ускоренного обучения.
                </li>
                <li className={speaker.speaker_innerCol_listStr}>
                  Благодаря использованию методик эффективного обучения в&nbsp;14&nbsp;лет <br/>
                  закончил школу, а&nbsp;юридический факультет СПбГУ со&nbsp;средним <br/>
                  баллом 4,8 —&nbsp;в&nbsp;20&nbsp;лет.
                </li>
                <li className={speaker.speaker_innerCol_listStr}>
                  В&nbsp;21&nbsp;год открыл собственную юридическую компанию.
                </li>
                <li className={speaker.speaker_innerCol_listStr}>
                  К&nbsp;24&nbsp;годам стал топ-менеджером финской компании Konecranes <br/>
                  (мировой лидер в&nbsp;области промышленной грузоподъемной техники).
                </li>
                <li className={speaker.speaker_innerCol_listStr}>
                  В&nbsp;данный момент Александр является генеральным директором <br/>
                  и&nbsp;соучредителем центра образовательных технологий Николая Ягодкина
                  Advance.
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};
